import { cx } from "@jugl-web/utils";
import React from "react";
import Markdown from "markdown-to-jsx";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { AIAssistantPromptSuggestion } from "@jugl-web/domain-resources/ai-assistant/AIAssistantPromptSuggestion";
import { useAIAssistant } from "@jugl-web/domain-resources/ai-assistant/providers";
import { Linkify } from "@jugl-web/utils/utils/Linkify";
import arivuImage from "../../assets/arivu.png";
import loadingAnimation from "./assets/loading.json";

export const AIMessageBubble: React.FC<{
  content?: string;
  isOutgoing?: boolean;
  isLoading?: boolean;
  suggestions?: string[];
  isLast?: boolean;
}> = ({ content, isOutgoing, isLoading, suggestions, isLast }) => {
  const { sendMessage } = useAIAssistant();

  return (
    <div className="flex flex-col gap-[14px]">
      <div className="group flex items-end gap-1">
        {!isOutgoing && (
          <div className="mb-2.5 h-6 w-6 shrink-0 overflow-hidden rounded-full border border-solid border-grey-200 bg-white">
            <img
              src={arivuImage as unknown as string}
              className="h-full w-full object-cover"
              alt=""
            />
          </div>
        )}
        <div className={cx("flex flex-col gap-1", isOutgoing && "ml-auto")}>
          <div
            className={cx(
              "max-w-[600px] rounded-xl p-2.5",
              isOutgoing
                ? "rounded-br-none bg-[#826BCC] text-white"
                : "rounded-bl-none text-dark"
            )}
          >
            {isLoading ? (
              <Lottie
                options={{ animationData: loadingAnimation }}
                width={36}
              />
            ) : !isOutgoing ? (
              <Markdown
                className="jugl__break-word font-secondary text-sm whitespace-pre-wrap"
                options={{
                  overrides: {
                    h1: <span className="my-3 text-lg" />,
                    h2: <span className="my-2 text-base" />,
                    h3: <span className="my-1 text-base" />,
                    p: <p className="mt-1 mb-0" />,
                    a: {
                      component: ({ children, ...props }) => (
                        <a {...props} target="_blank" rel="noopener noreferrer">
                          {children}
                        </a>
                      ),
                    },
                  },
                }}
              >
                {content || ""}
              </Markdown>
            ) : (
              <Linkify className="text-inherit underline">{content}</Linkify>
            )}
          </div>
        </div>
      </div>
      {isLast && suggestions && (
        <div className="flex flex-col gap-4">
          {suggestions.map((suggestion, idx) => (
            <AIAssistantPromptSuggestion
              key={+idx}
              prompt={suggestion}
              onClick={() => sendMessage(suggestion)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
